import React, { Fragment } from "react";
import FadeInUp from "../../shared/animations/fadeInUp";
import VisibilitySensor from 'react-visibility-sensor';

export default function IntroBlock() {
  return (
    <Fragment>
      <VisibilitySensor partialVisibility={true}>
        {({ isVisible }) =>
          <Fragment>
            <div className="col-md-6 mb-5 mb-md-0">
              <FadeInUp once fadeIn={isVisible ? true : false}>
                <div className="mb-5 pb-2">
                  <h3>Behandelingen</h3>

                  <h4>Alle soorten pijn</h4>
                  <p>Zowel bij chronische als acute pijn en fysieke of mentale ongemakken.</p>

                  <h4>Ondersteuning bij kanker</h4>
                  <p>Verlichting van de bijwerkingen van de kankerbehandeling en de kanker zelf.</p>

                  <h4>Gynaecologische en zwangerschapsproblemen</h4>
                  <p>Fertiliteit, menstruatieveranderingen, bijwerkingen menopauze, zwangerschapskwalen, kering van de baby, enz.</p>

                  <h4>Andere inwendige ziekten (acuut en chronisch)</h4>
                  <p>Spijsvertering, dermatologie, ontstekingen, immunologie, enz.</p>

                  <h4>Preventieve behandeling</h4>
                  <p>Je gezondheid verbeteren en je lichaam weerbaarder maken tegen ziekten.</p>

                  <h4>Lichaamsdetox met cupping</h4>
                  <p>Je lichaam ontgiften via cupping en massage.</p>
                </div>
              </FadeInUp>
            </div>
          </Fragment>
        }
      </VisibilitySensor>
      <div className="col-md-5 offset-sm-1 d-flex align-items-center">
        <VisibilitySensor partialVisibility={true}>
          {({ isVisible }) =>
            <FadeInUp once delay='300' fadeIn={isVisible ? true : false}>
              <div className="position-relative">
                <p className="quote secondary-darken">Mijn handen zijn gemaakt om te genezen. Het geeft me energie en het maakt me gelukkig.</p>
              </div>
            </FadeInUp>
          }
        </VisibilitySensor>
      </div>
    </Fragment>
  );
}
